import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { StoreDevtoolsName } from '../store-names.const'

import { sessionInitialState } from './session.slice'
import type { SessionStore } from './session.type'

export type { SessionStore, SessionStoreActions, SessionStoreState } from './session.type'
export const useSessionStore = create<SessionStore>()(
  devtools(
    immer((set) => ({
      ...sessionInitialState,
      setToken: (token) =>
        set((state) => {
          state.token = token
          state.lastFetched = token ? Date.now() : null
        }),
      setLoading: (loading) =>
        set((state) => {
          state.isLoading = loading
        }),
      setError: (error) =>
        set((state) => {
          state.error = error
        }),
      clearToken: () =>
        set((state) => {
          state.token = null
          state.lastFetched = null
          state.error = null
        }),
    })),
    {
      name: StoreDevtoolsName.Session,
      enabled: process.env.NODE_ENV === 'development',
    }
  )
)
